import { ListCard, Skeleton, SkeletonItem } from '@capsicum/common-web';
import { type WalletTokenTotalBalance } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

export type WalletFanTokenBalanceProps = {
	item?: WalletTokenTotalBalance;
	label?: string;
};

export const WalletFanTokenBalance = ({ item, label }: WalletFanTokenBalanceProps) => {
	const { altCurrency, defaultCurrency } = item?.walletConvertedPrices ?? {};

	return (
		<S.ListCardWrapper testID="wallet-fanToken-totalBalance">
			<S.ListCardContent>
				<ListCard.Row>
					<ListCard.Title>{label}</ListCard.Title>
					<S.ListCardText>
						{!item && (
							<Skeleton>
								<SkeletonItem width="6ch" />
							</Skeleton>
						)}
						{item?.formattedTotalBalanceOfFanTokens}
					</S.ListCardText>
				</ListCard.Row>
				<S.ListCardRowRight>
					{(!item || defaultCurrency?.totalAmountOfFanToken) && (
						<ListCard.SubTitle>
							<S.DefaultCurrencyContainer>
								{!item && (
									<Skeleton>
										<SkeletonItem width="25ch" />
									</Skeleton>
								)}
								{defaultCurrency?.formattedTotalBalance}
							</S.DefaultCurrencyContainer>
							{altCurrency?.totalAmountOfFanToken && (
								<S.altCurrencyContainer>{`≈${altCurrency?.formattedTotalBalance}`}</S.altCurrencyContainer>
							)}
						</ListCard.SubTitle>
					)}
				</S.ListCardRowRight>
			</S.ListCardContent>
		</S.ListCardWrapper>
	);
};
namespace S {
	export const ListCardWrapper = styled(ListCard)`
		width: 100%;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.subtle};
	`;
	export const ListCardContent = styled(ListCard.Content)`
		padding: ${({ theme }) => `0 ${theme.spacings.small}`};
	`;
	export const ListCardText = styled(ListCard.Text)`
		${({ theme }) => theme.fonts.text.text1}
	`;
	export const ListCardRowRight = styled(ListCard.Row)`
		justify-content: flex-end;
	`;
	export const DefaultCurrencyContainer = styled.span`
		${({ theme }) => theme.fonts.text.caption1}
	`;
	export const altCurrencyContainer = styled.span`
		padding-left: ${({ theme }) => theme.spacings.xxsmall};
		${({ theme }) => theme.fonts.text.caption2}
	`;
}
